import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { loadRuntimeConfig } from './runtime.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 5_000 }, mutations: { retry: 0 } },
});

async function bootstrap() {
  const config = await loadRuntimeConfig();
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: { username: true, email: true },
      },
    },
  });
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element is missing');
  createRoot(root).render(
    <StrictMode>
      <Authenticator hideSignUp>
        {({ signOut, user }) => (
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <div className="session-bar">
                <span>{user?.signInDetails?.loginId}</span>
                <button onClick={signOut}>サインアウト</button>
              </div>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        )}
      </Authenticator>
    </StrictMode>,
  );
}

void bootstrap().catch((error: unknown) => {
  const root = document.getElementById('root');
  if (root) root.textContent = error instanceof Error ? error.message : '起動に失敗しました';
});

